<template>
  <!-- 有子菜单：渲染为 submenu -->
  <el-submenu v-if="hasChildren" :index="item.path">
    <template slot="title">
      <i :class="iconClass"></i>
      <span>{{ item.name }}</span>
    </template>
    <sidebar-item v-for="child in visibleChildren" :key="child.id || child.path" :item="child"
      :is-collapse="isCollapse" />
  </el-submenu>
  <!-- 无子菜单：渲染为 menu-item -->
  <el-menu-item v-else :index="item.path">
    <i :class="iconClass"></i>
    <span slot="title">{{ item.name }}</span>
  </el-menu-item>
</template>

<script>
// 后端菜单 icon 字段 → Element UI 图标 class 映射
const ICON_MAP = {
  setting: 'el-icon-setting',
  lock: 'el-icon-lock',
  user: 'el-icon-user',
  admin: 'el-icon-s-custom',
  refresh: 'el-icon-refresh',
  document: 'el-icon-document',
  edit: 'el-icon-edit',
  home: 'el-icon-s-home',
  order: 'el-icon-s-order',
  menu: 'el-icon-menu',
  list: 'el-icon-s-operation',
  info: 'el-icon-info',
  warning: 'el-icon-warning',
  search: 'el-icon-search',
  goods: 'el-icon-goods',
  people: 'el-icon-user-solid',
  present: 'el-icon-present',
  message: 'el-icon-message'
}

export default {
  name: 'SidebarItem',
  props: {
    item: {
      type: Object,
      required: true
    },
    isCollapse: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    // 侧边栏只渲染 type=10（菜单）的子项
    // type=20（子页面，如编辑页）不进侧边栏；type=30（按钮）后端已过滤
    visibleChildren() {
      if (!this.item.children || !this.item.children.length) return []
      return this.item.children.filter(child => child.type === 10)
    },
    hasChildren() {
      return this.visibleChildren.length > 0
    },
    iconClass() {
      const icon = this.item.icon
      if (!icon) return ''
      // 如果已经是 el-icon-xxx 格式直接用
      if (icon.startsWith('el-icon')) return icon
      return ICON_MAP[icon] || ''
    }
  }
}
</script>
